import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  "aria-modal": "true",
  class: "request-notes-dialog-wrapper"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "request-notes-dialog-text"
}
const _hoisted_4 = {
  key: 1,
  class: "request-notes-dialog-text"
}
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = ["aria-label"]

import { ref } from "vue";
import RequestNotesOrderForm from "./Orders/RequestNotesOrderForm.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestNotesModal',
  props: {
  sessionTitle: {
    type: String,
    required: true,
  },
  sessionDurationHMS: {
    type: String,
    required: true,
  },
  sessionDurationMS: {
    type: String,
    required: true,
  },
  uploadId: {
    type: String,
    required: true,
  },
  visible: {
    type: Boolean,
    required: true,
  },
  setVisible: {
    type: Function,
    required: true,
  },
  showTimeLimitExceeded: {
    type: Boolean,
    default: false,
  }
},
  emits: ["goHome"],
  setup(__props, { emit: __emit }) {

const OnboardingRecordNotesImage = require("../assets/images/Onboarding-record-notes.png") as string;
const props = __props;

const emit = __emit;

const orderFormVisible = ref(false);

function setOrderFormVisible(visible: boolean) {
  orderFormVisible.value = visible;
}

function goHome() {
  emit("goHome");
  props.setVisible(false);
}

function delayedGoHome() {
  setTimeout(() => {
    goHome();
  }, 3000);
}

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: props.visible,
      header: "false",
      closable: false,
      class: "request-notes-dialog",
      modal: true,
      "aria-expanded": props.visible,
      "aria-label": 'Request professional notes',
      "close-on-escape": true
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(OnboardingRecordNotesImage),
            class: "record-notes-image"
          }, null, 8, _hoisted_2),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "request-notes-dialog-title" }, " Request professional notes? ", -1)),
          (props.showTimeLimitExceeded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " You’ve reached your 30-hour limit. Order professional notes with a one-time payment to reset your hours. Or, subscribe for unlimited recording and more features. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, " Order professional notes and our experts will summarize key points for you. ")),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              autofocus: "",
              class: "buttons-request",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setOrderFormVisible(true))),
              "aria-label": 'Request professional notes for ' + props.sessionTitle,
              onKeydown: _cache[1] || (_cache[1] = ($event) => {
          if ($event.key === 'Enter') {
            setOrderFormVisible(true);
          }
        })
            }, " REQUEST NOTES ", 40, _hoisted_6),
            _createElementVNode("button", {
              onClick: goHome,
              class: "buttons-home",
              "aria-label": 'Maybe later',
              onKeydown: _cache[2] || (_cache[2] = ($event) => {
          if ($event.key === 'Enter') {
            goHome();
          }
        })
            }, "MAYBE LATER", 32)
          ])
        ])), [
          [_directive_focustrap]
        ])
      ]),
      _: 1
    }, 8, ["visible", "aria-expanded"]),
    _createVNode(RequestNotesOrderForm, {
      visible: orderFormVisible.value,
      recordingTitle: props.sessionTitle,
      recordingUploadId: props.uploadId,
      setOrderFormVisible: setOrderFormVisible,
      onOrderSuccessful: delayedGoHome,
      durationHMS: props.sessionDurationHMS,
      durationMilliseconds: props.sessionDurationMS
    }, null, 8, ["visible", "recordingTitle", "recordingUploadId", "durationHMS", "durationMilliseconds"])
  ], 64))
}
}

})